import { Card, CardBody, Col } from "reactstrap";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { AbsoluteCards } from "../../../../Constant";
import { Image, P } from "../../../../AbstractElements";
import { CARD_ABSOLUTE } from "../../../../Data/Bonus Ui/CreativeCard";

const AbsoluteCard = () => {
  return (
    <>
      {CARD_ABSOLUTE.map(({ className, src, span }, index) => (
        <Col sm="12" xl="6" key={index}>
          <Card className="card-absolute">
            <CommonCreativeCardHeader headerClass={className} title={AbsoluteCards} titleClass="text-white" />
            <CardBody>
              <div className="d-flex list-behavior-1 align-items-center">
                <div className="flex-shrink-0">
                  <Image className="tab-img b-r-0 img-fluid" src={src} alt="home" />
                </div>
                <div className="flex-grow-1">
                  <P className="mb-xl-0 mb-sm-4">{span}</P>
                </div>
              </div>    
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};

export default AbsoluteCard;
